var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-item-wrapper', {
    attrs: {
      "designer": _vm.designer,
      "field": _vm.field,
      "rules": _vm.rules,
      "design-state": _vm.designState,
      "parent-widget": _vm.parentWidget,
      "parent-list": _vm.parentList,
      "index-of-parent-list": _vm.indexOfParentList,
      "sub-form-row-index": _vm.subFormRowIndex,
      "sub-form-col-index": _vm.subFormColIndex,
      "sub-form-row-id": _vm.subFormRowId
    }
  }, [_c('el-time-picker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadMode),
      expression: "!isReadMode"
    }],
    ref: "fieldEditor",
    staticClass: "full-width-input",
    attrs: {
      "is-range": "",
      "disabled": _vm.field.options.disabled,
      "readonly": _vm.field.options.readonly,
      "clearable": _vm.field.options.clearable,
      "editable": _vm.field.options.editable,
      "format": _vm.field.options.format,
      "value-format": "HH:mm:ss",
      "start-placeholder": _vm.field.options.startPlaceholder || _vm.i18nt('render.hint.startTimePlaceholder'),
      "end-placeholder": _vm.field.options.endPlaceholder || _vm.i18nt('render.hint.endTimePlaceholder')
    },
    on: {
      "focus": _vm.handleFocusCustomEvent,
      "blur": _vm.handleBlurCustomEvent,
      "change": _vm.handleChangeEvent
    },
    model: {
      value: (_vm.fieldModel),
      callback: function($$v) {
        _vm.fieldModel = $$v
      },
      expression: "fieldModel"
    }
  }), _vm._v(" "), (_vm.isReadMode) ? [_c('span', {
    staticClass: "readonly-mode-field"
  }, [_vm._v(_vm._s(_vm.contentForReadMode))])] : _vm._e()], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ad2f4","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/field-widget/time-range-widget.vue
// module id = null
// module chunks = 